<template>
  <div class="block__loader-page">
    <div class="loader-container">
      <i class="mask-24 mask-loading loader-icon" />
    </div>
  </div>
</template>
